module.exports = __webpack_public_path__ + "static/media/activate-account.4e545f15.svg";